import { Button, Flex, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  NoPendingTasksWrapper,
  PendingTasksWrapper,
  WidgetTitle,
  WidgetWrapper
} from '../shared/WidgetShared.styles';

import { Timeline } from './components';
import { PlanificationModal } from './components';
import { AllTaskCompleted } from './components/AllTaskCompleted';
import { SelectedDayTasksList } from './components/SelectedDayTasksList';
import { TaskWrapper, TitleWrapper, VerticalMenuButton } from './TasksWidget.styles';

import { Icon } from '@/components/Icon';
import { Box } from '@/components/Utils';
import { usePlanificationStates } from '@/hooks';
import { usePlanificationTimeline } from '@/hooks/usePlanificationTimeline';

export const TasksWidget: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const navigateTo = useNavigate();
  const { handleCreatePlanification } = usePlanificationStates();
  const {
    hasPlanification,
    planificationDates,
    completedTasksCountSelectedDate,
    totalTasksCountSelectedDate
  } = usePlanificationTimeline();

  if (!hasPlanification || planificationDates.length === 0) {
    return null;
  }

  const content = (
    <Box display="flex" flexDirection="column">
      <VerticalMenuButton type="text" onClick={handleCreatePlanification}>
        {t('REPLANIFY')}
      </VerticalMenuButton>
      <VerticalMenuButton type="text" onClick={() => navigateTo('/calendar')}>
        {t('SEE_CALENDAR')}
      </VerticalMenuButton>
    </Box>
  );

  return (
    <TaskWrapper>
      <Timeline />
      <WidgetWrapper>
        <TitleWrapper>
          <Flex align="center" gap={8}>
            <WidgetTitle>{t('TASKS')}</WidgetTitle>{' '}
            {totalTasksCountSelectedDate > 0 ? (
              <PendingTasksWrapper>
                {t('COMPLETED_TASKS', {
                  completed: completedTasksCountSelectedDate,
                  total: totalTasksCountSelectedDate
                })}
              </PendingTasksWrapper>
            ) : (
              <NoPendingTasksWrapper>0</NoPendingTasksWrapper>
            )}
          </Flex>
          <Popover placement="bottomRight" trigger="click" content={content}>
            <Button type="text" icon={<Icon i="OverflowMenuVertical" />} />
          </Popover>
        </TitleWrapper>
        {totalTasksCountSelectedDate > 0 &&
          completedTasksCountSelectedDate === totalTasksCountSelectedDate && <AllTaskCompleted />}
        <SelectedDayTasksList />
      </WidgetWrapper>
      <PlanificationModal />
    </TaskWrapper>
  );
};
